import React, { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import FullPageLayout from "../../components/FullPageLayout/FullPageLayout";
import { usePortalDefinition } from "../../hooks/use-portal-definition";
import { SitePage } from "../../types/SitePage";
import VCNOnboardingPage from "../VCNOnboardingPage/VCNOnboardingPage";
import "./SplashPage.scss";

const SplashPage: React.FC = () => {
  const navigate = useNavigate();
  const handleSplashClick = useCallback(() => {
    navigate("/about");
  }, [navigate]);

  const { investorPortal } = usePortalDefinition();
  if (investorPortal) {
    return <VCNOnboardingPage />;
  }

  return (
    <FullPageLayout page={SitePage.Splash} title="Hello">
      <div
        className="text-wrapper d-flex justify-content-center align-items-center h-100 w-100"
        onClick={handleSplashClick}
      >
        <code>VCDB</code>
      </div>
    </FullPageLayout>
  );
};

export default SplashPage;
